import Query from "../../core/query/query";
export class TagAdministrationQuery extends Query {
}